import StyledLink from '../StyledLink'
import {
  CUSTOM_SCRIPT,
  EDIT,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

interface Params {
  id: string
}

const LinkToEditCustomScript = ({
  children,
  id,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SYSTEM + '/' + CUSTOM_SCRIPT + '/' + id + '/' + EDIT}
  >
    {children}
  </StyledLink>

export default LinkToEditCustomScript
